import { z } from 'zod';

import { Payment } from '../loan/Payments';
import { BaseLoanEvent } from './BaseLoanEvent';

/**
 * A payment recorded toward a Chapter 13 pre-petition plan (from the trustee or borrower).
 *
 * Kept as its own event rather than a flag on {@link CreatePaymentEvent}: `createPayment` is already
 * overloaded, and — critically — the pre-petition treatment must live on the breakdown, not the payment.
 * If the plan is later reversed, the payment reverts to unapplied and the lender reallocates it freely;
 * a residual pre-petition marker on the payment object would fight that.
 */
export const CreatePrePetitionPaymentEvent = BaseLoanEvent.extend({
  type: z.literal('createPrePetitionPayment'),
  payment: Payment,
});
export type CreatePrePetitionPaymentEvent = z.infer<typeof CreatePrePetitionPaymentEvent>;
